<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <v-row>
          <v-col
            :md="!isSocialRoute ? 6 : ''"
            class="mt-2 pb-0"
            cols="12"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.organizationName"
                append-icon="mdi-account-outline"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                class="contentinfo"
                dense
                :hint="$t('voice_gallery_title_hint')"
                :label="$t('voice_gallery_title')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-organizationName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('voice_gallery_title')"
              />
            </div>
          </v-col>
          <v-col
            v-if="!isSocialRoute"
            :md="!isSocialRoute ? 6 : ''"
            class="mt-2 pb-0"
            cols="12"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.subtitle"
                append-icon="mdi-account-outline"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="100"
                class="contentinfo"
                dense
                :hint="$t('voice_gallery_subtitle_hint')"
                :label="$t('voice_gallery_subtitle')"
                maxLength="100"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-subtitle`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('voice_gallery_subtitle_alt')"
              />
            </div>
          </v-col>
          <v-col class="mt-2 py-0" cols="12">
            <div class="rowinfo">
              <v-text-field
                v-model="data.website"
                :rules="urlRules"
                append-icon="mdi-earth"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                :hint="$t('website_address_hint')"
                :label="$t('website_address')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-website`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('website_address')"
              />
            </div>
          </v-col>
          <v-col
            v-if="
              ![
                'qr.name.editPhoto',
                'qr.name.id.editPhoto',
                'qr.photo',
                'qr.create.photoGalleryModel',
                'qr.create.photoGalleryedit',
                'qr.video',
                'qr.name.editVideo',
                'qr.name.id.editVideo',
              ].includes($route.name)
            "
            class="mt-2 py-0"
            cols="12"
          >
            <div class="rowinfo">
              <suggest-text
                v-model="data.aboutUs"
                :label="$t('about_voice_gallery')"
                rows="8"
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-aboutUs`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('about_voice_gallery_alt')"
              />
            </div>
          </v-col>

          <v-col
            v-if="
              [
                'qr.name.editPhoto',
                'qr.name.id.editPhoto',
                'qr.photo',
                'qr.create.photoGalleryModel',
                'qr.create.photoGalleryedit',
                'qr.video',
                'qr.name.editVideo',
                'qr.name.id.editVideo',
              ].includes($route.name)
            "
            class="mt-2 py-0"
            cols="12"
          >
            <extra-fileds v-model="data.extraFields" block />
          </v-col>
          <v-col
            v-if="isSocialRoute"
            class="mt-2 py-0"
            cols="12"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.buttonName"
                append-icon="mdi-account-outline"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="100"
                dense
                :hint="$t('button_name_hint')"
                :label="$t('button_name')"
                maxLength="100"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-buttonName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('button_name')"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import SuggestText from "@/view/components/SuggestBox/suggestInput";
import IconPicker from "@/view/components/IconPicker";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import ExtraFileds from "../../../components/Product/extraFileds.vue";

export default {
  name: "baseInfoVoice",
  components: {
    ExtraFileds,
    IconPicker,
    SuggestText,
    HelpInfo,
    HelpInfoWrapper,
  },
  props: {
    data: {
      default: {},
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "base-info-voice",
      urlRules: [(value) => this.isURL(value) || this.$t("domain_format_hint")],
    };
  },
  computed:{
          isSocialRoute(){
    return ['qr.create.editSocialModel',
    'qr.create.SocialMediaModel',
    'qr.socialMedia','qr.name.id.editSocial',
    'qr.name.editSocial'].includes(this.$route.name);
    }

  },
  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
